import { render } from "./VehicleInvite.vue?vue&type=template&id=675794a2&scoped=true"
import script from "./VehicleInvite.vue?vue&type=script&lang=js"
export * from "./VehicleInvite.vue?vue&type=script&lang=js"

import "./VehicleInvite.vue?vue&type=style&index=0&id=675794a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675794a2"]])

export default __exports__